.<template>
  <button
    v-show="enableReset"
    data-toggle="tooltip"
    title="Alterar Senha"
    class="btn btn-crud key"
    @click="reset(props.row.id)"
  >
    <i class="fas fa-key" data-toggle="tooltip" title="Resetar Senha"></i>
  </button>
</template>

<script>
export default {
  props: {
    enableReset: Boolean,
  },
  computed: {
    url() {
      return (
        this.$store.getters.api + this.endPoint + (this.with ? this.with : "")
      );
    },
  },
  methods: {
    reset(id) {
      this.$router.push({
        path: this.endPoint + "resetpassword/" + id,
      });
    },
  },
};
</script>

<style>
.key {
  border: 2px solid #ff7301;
}
</style>


// WEBPACK FOOTER //
// src/components/Utils/enableResetPassword.vue